import { Link, useLocation } from "react-router-dom";
import { Facebook, Instagram, MapPin } from "lucide-react";
import { CABINETS } from "../data/content";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/trek-sahara" || pathname === "/formation-chi-nei-tsang" || pathname === "/formation-reflexologie-plantaire") return null;

  return (
    <footer data-testid="site-footer" className="bg-olive-dark text-beige-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/images/logo-icon.png" alt="" className="h-8 w-8 object-contain invert opacity-90" />
            <span className="font-serif text-2xl">Julie Zittel</span>
          </div>
          <p className="text-sm text-beige-300/80 leading-relaxed max-w-xs">
            Thérapeute & formatrice — médecine chinoise, magnétisme, sophrologie, ostéothérapie. Accompagnement vers le bien-être, l'équilibre et la liberté intérieure.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="https://www.instagram.com/juliezittel/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram de Julie Zittel" className="flex h-10 w-10 items-center justify-center rounded-full border border-beige-100/25 text-beige-200 transition-all duration-300 hover:bg-beige-100 hover:text-olive-dark hover:-translate-y-0.5">
              <Instagram className="w-5 h-5" strokeWidth={1.5} />
            </a>
            <a href="https://www.facebook.com/julieosteotheotherapeute" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook de Julie Zittel" className="flex h-10 w-10 items-center justify-center rounded-full border border-beige-100/25 text-beige-200 transition-all duration-300 hover:bg-beige-100 hover:text-olive-dark hover:-translate-y-0.5">
              <Facebook className="w-5 h-5" strokeWidth={1.5} />
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-beige-300/70 mb-5">Navigation</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link data-testid="footer-link-soins" to="/soins" className="text-beige-200/90 hover:text-beige-100 transition-colors">Les soins</Link>
            <Link data-testid="footer-link-formations" to="/formations" className="text-beige-200/90 hover:text-beige-100 transition-colors">Formations</Link>
            <Link data-testid="footer-link-sejour" to="/sejour-initiatique" className="text-beige-200/90 hover:text-beige-100 transition-colors">Séjour initiatique</Link>
            <Link data-testid="footer-link-blog" to="/blog" className="text-beige-200/90 hover:text-beige-100 transition-colors">Le Journal</Link>
            <Link data-testid="footer-link-guide" to="/guides" className="text-beige-200/90 hover:text-beige-100 transition-colors">Guides offerts</Link>
            <Link data-testid="footer-link-contact" to="/contact" className="text-beige-200/90 hover:text-beige-100 transition-colors">Contact</Link>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-beige-300/70 mb-5">Où me trouver</p>
          <div className="flex flex-col gap-4">
            {CABINETS.map((c) => (
              <div key={c.city} className="flex items-start gap-3 text-sm text-beige-200/90">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-beige-300" strokeWidth={1.5} />
                <span>{c.address}, {c.zip}</span>
              </div>
            ))}
          </div>
          <p className="mt-5 text-xs text-beige-300/70">Avis clients consultables sur Google & Facebook.</p>
          <p className="mt-4 text-[11px] leading-relaxed text-beige-300/50">
            Julie Zittel, thérapeute et formatrice à Bayonne et Bellignat : réflexologie plantaire, médecine chinoise, Chi Nei Tsang, massage bien-être, drainage lymphatique, ventouses, magnétisme, sophrologie, ostéothérapie, soins énergétiques, constellations familiales, breathwork, formations en massothérapie et trek initiatique au Sahara.
          </p>
        </div>
      </div>
      <div className="border-t border-beige-100/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-beige-300/60">
          <span>© {new Date().getFullYear()} Julie Zittel — Tous droits réservés</span>
          <span className="italic font-serif text-sm">« Avec amour, Julie »</span>
        </div>
      </div>
    </footer>
  );
}
